import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api` });

export const getToken = () => localStorage.getItem("srpc_token");
export const setToken = (t) => (t ? localStorage.setItem("srpc_token", t) : localStorage.removeItem("srpc_token"));

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const errMsg = (e) => e?.response?.data?.detail
  ? (typeof e.response.data.detail === "string" ? e.response.data.detail : "Datos inválidos")
  : "Error de conexión";

export const fileUrl = (u, priv = false) => {
  if (!u) return "";
  if (!u.startsWith("/api")) return u;
  return `${BACKEND}${u}${priv ? `?auth=${getToken()}` : ""}`;
};

export const photoUrl = (p) => fileUrl(p?.url || "");

export const waNumber = (n) => {
  const d = (n || "").replace(/\D/g, "");
  return /^8[024]9/.test(d) ? `1${d}` : d;
};

export const waLink = (n, msg) => `https://wa.me/${waNumber(n)}?text=${encodeURIComponent(msg)}`;

export const money = (v, cur = "USD") =>
  `${cur === "DOP" ? "RD$" : "US$"} ${Number(v || 0).toLocaleString("es-DO", { maximumFractionDigits: 0 })}`;

export const usd = (v) => `US$ ${Number(v || 0).toLocaleString("es-DO", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const downloadAuth = async (path, filename) => {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};
